module.exports = __webpack_public_path__ + "img/HK.796d459e.svg";